// The context that connects a dashboard cell to the kit `Card` (SEP-296).
//
// The canvas puts this context around each card. The kit `Card` reads it and
// fills the cell, collapses, and shows the edit chrome of the layout. Thus no
// card component of a module must change. Outside a canvas the value is null,
// and `Card` renders as before.

import { createContext, type ReactNode } from 'react';

export interface LayoutCardContextValue {
    /** True while the user edits the layout. The body of the card is then inert. */
    readonly editing: boolean;
    /** A card in a canvas always fills the height of its cell. */
    readonly fill: true;
    /** True: the card shows its header only. */
    readonly collapsed: boolean;
    /** The chrome before the title (the grip), or null. */
    readonly leading: ReactNode;
    /** The chrome after the meta and the actions (width, hide, menu), or null. */
    readonly trailing: ReactNode;
}

export const LayoutCardContext = createContext<LayoutCardContextValue | null>(null);
